module.exports = __webpack_public_path__ + "assets/img/34_702_big.0c51a2e6.jpg";